module.exports = __webpack_public_path__ + "img/wifi-serious.18a869bd.svg";